import { coreApi } from '@cp/shared/api/core';
import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { AdminClientPhotoCreateRequest, AdminClientPhotoCreateResponse } from '@common/model/client/photo/admin.request';
import { AdminClientProfileViewModel } from '@common/model/client/profile/adminClientProfileViewModel';
import { ModerationApiTags, moderationApiTagTypes } from 'src/entities/moderation';
import { AdminCatalogItemApiTag, adminCatalogItemApiTags } from 'src/entities/catalog/item';
import { ClientPatronageApiTag, clientPatronageApiTags } from 'src/entities/client/patronage';

const BASE_URL = '/admin/clients';

export const coreClientPhotoApi = coreApi
  .enhanceEndpoints({ addTagTypes: [...moderationApiTagTypes, ...adminCatalogItemApiTags, ...clientPatronageApiTags] as const })
  .injectEndpoints({
    endpoints: (builder) => ({
      createClientPhoto: builder.mutation<
        AdminClientPhotoCreateResponse,
        AdminClientPhotoCreateRequest & {
          clientId: ApiServerEntityIDType;
          /**
           * Used for tag invalidation
           */
          clientProfile?: AdminClientProfileViewModel;
        }
      >({
        query: ({ clientId, clientProfile, original, cropped, purpose, keepPreviousPhotos, skipPatronageUpdate }) => {
          const body = new FormData();
          body.append('original', original);
          body.append('cropped', cropped);
          body.append('purpose', purpose);
          if (keepPreviousPhotos !== undefined) {
            body.append('keepPreviousPhotos', keepPreviousPhotos.toString());
          }
          if (skipPatronageUpdate !== undefined) {
            body.append('skipPatronageUpdate', skipPatronageUpdate.toString());
          }

          return {
            url: `${BASE_URL}/${clientId}/photos`,
            method: 'POST',
            body,
          };
        },
        invalidatesTags: (_res, _err, { clientProfile }) => [
          ModerationApiTags.Moderation,
          ...(clientProfile?.mainResumeId ? [{ type: AdminCatalogItemApiTag.Item, id: clientProfile?.mainResumeId }] : []),
          ClientPatronageApiTag.List,
        ],
      }),

      deleteClientPhoto: builder.mutation<void, { clientId: ApiServerEntityIDType; id: ApiServerEntityIDType }>({
        query: ({ clientId, id }) => ({
          url: `${BASE_URL}/${clientId}/photos/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: () => [ModerationApiTags.Moderation],
      }),
    }),
  });
